/**
 * Storage Service
 * Handles secure storage of tokens and user data
 */

const TOKEN_KEY = 'erp_access_token';
const REFRESH_TOKEN_KEY = 'erp_refresh_token';
const USER_KEY = 'erp_user';

export class StorageService {
  /**
   * Get access token from storage
   */
  static getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  }

  /**
   * Set access token in storage
   */
  static setToken(token: string): void {
    localStorage.setItem(TOKEN_KEY, token);
  }

  /**
   * Get refresh token from storage
   */
  static getRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  }

  /**
   * Set refresh token in storage
   */
  static setRefreshToken(token: string): void {
    localStorage.setItem(REFRESH_TOKEN_KEY, token);
  }

  /**
   * Get user data from storage
   */
  static getUser(): any {
    const user = localStorage.getItem(USER_KEY);
    return user ? JSON.parse(user) : null;
  }

  /**
   * Set user data in storage
   */
  static setUser(user: any): void {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  /**
   * Check if user is authenticated
   */
  static isAuthenticated(): boolean {
    return !!this.getToken();
  }

  /**
   * Clear all auth data
   */
  static clearAuth(): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  }

  /**
   * Get all auth data
   */
  static getAuthData() {
    return {
      token: this.getToken(),
      refreshToken: this.getRefreshToken(),
      user: this.getUser(),
    };
  }

  /**
   * Set all auth data
   */
  static setAuthData(token: string, refreshToken: string | null, user: any): void {
    this.setToken(token);
    if (refreshToken) {
      this.setRefreshToken(refreshToken);
    }
    this.setUser(user);
  }
}

export default StorageService;
